import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { EPopup } from '@src/types/common';
import AddTo from './components/AddTo';
import CreateCollection from './components/CreateCollection';
import { popupsAtom, collectOverlayAtom, setPopup } from '@src/state/popupAtoms';
import { PopupOverlay } from '@src/components/PopupOverlay';

const CollectOverlay: FC = () => {
  const show = useAtomValue(popupsAtom)[EPopup.collectOverlay];
  const overlay = useAtomValue(collectOverlayAtom);

  if (!overlay.media) return null;

  const close = () => setPopup(EPopup.collectOverlay, false);

  return (
    <PopupOverlay show={!!show} onClose={close}>
      {window.reactSwitch(overlay.step, [
        { val: 'add', elem: () => <AddTo media={overlay.media} /> },
        { val: 'new', elem: () => <CreateCollection media={overlay.media} isAutoCollection={overlay.isAutoCollection} onClose={close} /> },
      ])}
    </PopupOverlay>
  );
};

export default CollectOverlay;